module.exports = __webpack_public_path__ + "img/Cyprus.d76ccdef.png";